const NO_DELIVERYMAN = {
  noDeliverymanTitle: 'Sua loja não possui entregadores aprovados',
  noDeliverymanText:
    'Use o botão abaixo para adicionar e aprovar\nentregadores para atuarem na sua loja.',
  defaultButton: 'Adicionar entregador',
}

export default NO_DELIVERYMAN
